<script setup lang="ts">
import BrandLogo from "@/components/BrandLogo.vue"
import { CONTACT_ADDRESS, CONTACT_EMAIL } from "@/data/contact"
</script>
<template>
  <footer>
    <BrandLogo />
    <a :href="`mailto:${CONTACT_EMAIL}`">{{ CONTACT_EMAIL }}</a
    ><span class="footer-address">{{ CONTACT_ADDRESS }}</span
    ><a href="https://www.nitro-detex.com" target="_blank" rel="noopener noreferrer">www.nitro-detex.com</a
    ><RouterLink to="/#services">Drilling &amp; blasting</RouterLink
    ><RouterLink to="/contact">Contact</RouterLink>
  </footer>
</template>
